export const BRAND = {
  name: "Deco Sweet",
  tagline: "Doces que Encantam",
  logo: "/logo.png",
  whatsappNumber: "5511962417170",
  phoneDisplay: "(11) 96241-7170",
  instagram: "@_decosweet",
  instagramUrl: "https://instagram.com/_decosweet",
  email: "decosweetcake@gmail.com",
  location: "São Paulo – SP",
};

export const waLink = (msg = "Olá! Gostaria de fazer uma encomenda na Deco Sweet.") =>
  `https://wa.me/${BRAND.whatsappNumber}?text=${encodeURIComponent(msg)}`;

export const NAV_LINKS = [
  { label: "Início", href: "#inicio" },
  { label: "Bolos", href: "#categorias" },
  { label: "Doces", href: "#destaques" },
  { label: "Encomendas", href: "#encomendas" },
  { label: "Sobre Nós", href: "#sobre" },
  { label: "Contato", href: "#contato" },
];

export const CATEGORIES = [
  {
    key: "bolos",
    title: "Bolos",
    desc: "Camadas artesanais para celebrar cada momento.",
    image:
      "https://images.unsplash.com/photo-1621868402792-a5c9fa6866a3?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    key: "doces",
    title: "Doces",
    desc: "Brigadeiros gourmet e finos docinhos feitos à mão.",
    image:
      "https://images.pexels.com/photos/37306625/pexels-photo-37306625.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    key: "salgados",
    title: "Salgados",
    desc: "Salgados artesanais para festas e momentos especiais.",
    image:
      "https://images.pexels.com/photos/958545/pexels-photo-958545.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=800",
  },
];
